import { ITreeNode } from '../../../../../../interface/interfaces';

export const getRandomNodes = (data: ITreeNode[], count: number): ITreeNode[] => {
    const shuffled = [...data].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
};
